module.exports = __webpack_public_path__ + "img/Edit.7026a0ec.svg";